import React, { memo } from 'react';
import { CTAButton } from './CTAButton';
export const HeroSection = memo(function HeroSection() {
  const CHECKOUT_URL = '#compra';
  return <section className="relative overflow-hidden min-h-screen flex items-center justify-center px-4 pt-14 pb-20" data-id="element-95">
      <style data-id="element-96">{`
        @keyframes float {
          0%   { transform: translateY(0px); }
          50%  { transform: translateY(-14px); }
          100% { transform: translateY(0px); }
        }
        .animate-float {
          animation: float 4s ease-in-out infinite;
        }
      `}</style>

      {/* Background */}
      <img src="https://cdn.magicpatterns.com/uploads/ehXocraeJf13oboyH8uykq/ChatGPT_Image_1_abr_2026,_01_47_02.webp" alt="Fondo taller eléctrico" fetchPriority="high" loading="eager" decoding="async" width="1456" height="816" className="absolute inset-0 w-full h-full object-cover opacity-70" data-id="element-97" />

      {/* Overlay - layered for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-gray-950/60 via-gray-950/50 to-gray-950/95" data-id="element-98" />
      <div className="absolute inset-0 bg-gradient-to-t from-gray-950 via-transparent to-transparent opacity-40" data-id="element-99" />

      {/* Contenido */}
      <div className="relative z-10 text-center w-full max-w-sm md:max-w-4xl mx-auto flex flex-col items-center gap-2" data-id="element-100">
        {/* Badge */}
        <div className="inline-block bg-blue-500/15 border border-blue-400/30 text-blue-400 text-[10px] md:text-xs font-bold uppercase tracking-[0.15em] px-5 py-2 rounded-full mb-4 backdrop-blur-sm" data-id="element-101">
          ⚡ Megapack Electricista en Casa — El Método N°1 de Argentina
        </div>

        {/* Título Principal */}
        <h1 className="font-black leading-none tracking-tight mb-4" data-id="element-102">
          <span className="block text-[30px] md:text-6xl lg:text-7xl text-white mb-3 leading-[1.1] drop-shadow-[0_2px_8px_rgba(0,0,0,0.5)]" data-id="element-103">
            ¿Pagaste una fortuna <br className="hidden md:block" data-id="element-104" />
            por un arreglo de <span className="text-blue-400" data-id="element-105">20 minutos?</span>
          </span>
          <span className="block text-[14px] md:text-xl lg:text-2xl text-white/60 font-semibold mt-5 leading-relaxed max-w-3xl mx-auto px-2 uppercase tracking-wider" data-id="element-106">
            Aprendé a resolver los problemas eléctricos de tu casa vos mismo.{' '}
            <br className="hidden md:block" data-id="element-107" />
            Sin miedo, sin técnicos, sin gastar de más.
          </span>
        </h1>

        {/* Mockup con levitación */}
        <a href={CHECKOUT_URL} className="animate-float block my-6 w-full max-w-[280px] md:max-w-[480px] mx-auto group" data-id="element-108">
          <img src="https://cdn.magicpatterns.com/uploads/nLEpS4NnyGQLSrS151uPXv/hf_20260401_023647_9f4fa364-ad82-4991-adac-833ce21ae051_(1).webp" alt="Megapack Electricista en Casa" className="w-full transition-all duration-500
              drop-shadow-[0_20px_50px_rgba(0,0,0,0.6)]
              group-hover:drop-shadow-[0_25px_60px_rgba(59,130,246,0.25)]
              group-hover:scale-[1.03]
              group-hover:brightness-110" width="665" height="371" fetchPriority="high" loading="eager" decoding="async" data-id="element-109" />
        </a>

        {/* CTA */}
        <CTAButton href={CHECKOUT_URL} text="⚡ QUIERO RESOLVER MIS PROBLEMAS ELECTRICOS" subtext="🔒 Compra protegida por MercadoPago — Garantía 30 días sin preguntas" data-id="element-110" />
      </div>
    </section>;
});